import React from "react"
import {
    ModalBackground,
    ModalContainer,
    CloseButton,
    ModalHeader,
    ModalFooter,
    ModalTitle,
    ModalMessage,
} from "./modalStyles"
import { RoundedButton, VerticalSpacer } from "@omnichannel/ace-b2b-elements"

/*
    How to use: 
    <button onClick={()=>{setShowModal(!showModal);}}> Show me the Modal </button>
    <ConfirmCancelModal
        showModal={showModal}
        closeModal={()=>{setShowModal(false);}}
        closeOnBackgroundTouch={true} //optional
        title={'confirm'} //optional
        message={'Are you sure you want to remove this item from your shopping bag yada yada blah bidi blah blah? '}
        onConfirm={()=>{setShowModal(false);}}
        onCancel={()=>{setShowModal(false);}}
        okText={'Okurrrr'} //optional
        cancelText={'wagnabeh'} // optional
    />
*/
const ConfirmCancelModal = props => {
    const {
        showModal,
        closeModal,
        closeOnBackgroundTouch = true, //optional
        title, //optional
        message,
        onConfirm,
        onCancel,
        okText,
        cancelText,
        style,
        modalOverlay,
        titleStyle,
        messageStyle,
    } = props
    var ref = React.createRef()

    return showModal ? (
        <ModalBackground
            backgroundColor={modalOverlay}
            onClick={e => {
                if (closeOnBackgroundTouch && e.target === ref.current) {
                    closeModal()
                }
            }}
            ref={ref}
            style={{ backgroundColor: 'transparent' }}
        >
            <ModalContainer style={style}>
                <ModalHeader>
                    <ModalTitle titleStyle={titleStyle}>{title}</ModalTitle>
                    <CloseButton onClick={closeModal}>&times;</CloseButton>
                </ModalHeader>
                <ModalMessage messageStyle={messageStyle}>{message}</ModalMessage>
                <ModalFooter>
                    <RoundedButton primary onClick={onConfirm} padding={"1rem 1.2rem"} fontWeight={500}>
                        {okText || `OK`}
                    </RoundedButton>
                    <VerticalSpacer width={"3.2rem"} />
                    <RoundedButton
                        onClick={onCancel}
                        padding={"1rem 1.2rem"}
                        fontWeight={500}
                        style={{
                            background: "#E7E3E6",
                            borderColor: "#E7E3E6",
                        }}
                    >
                        {cancelText || `Cancel`}
                    </RoundedButton>
                </ModalFooter>
            </ModalContainer>
        </ModalBackground>
    ) : (
            <div />
        )
}

export default ConfirmCancelModal